import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'masterpass-delete-card-form',
  templateUrl: './masterpass-delete-card-form.component.html',
  styleUrls: ['./masterpass-delete-card-form.component.scss'],
})
export class MasterpassDeleteCardFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
